module.exports = __webpack_public_path__ + "ecef4318677ec5821f095be51f2c3c48.svg";